import * as children from './pages/**/routes.js'; //eslint-disable-line

const PageInvoiceExtract = () => import('./PageInvoiceExtract');

export default {
  path: 'invoice',
  children: {
    invoiceExtract: {
      name: 'invoiceExtract',
      path: '',
      component: PageInvoiceExtract,
      meta: {
        title: 'Extrato da fatura',
      },
    },
    ...children,
  },
};



// WEBPACK FOOTER //
// ./src/features/private/client-environment/pages/invoice-extract/routes.js